// import "./header";
// import "./algemene";
// import "./filter-popup";
// import "./thankyou";
// import "./checkout";
import "./scssFormater";
